// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2j-UE","inner":"Footer_inner__fNkwA"};